import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import { CenterFocusStrong, CenterFocusWeak } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"

export default function ShowNotHeldButton({ includeNotHeld, toggleNotHeld, disabled }) {
  return <Tooltip title={`${includeNotHeld ? "Hide" : "Show"} benchmark names`}>
    <div>
      <IconButton
        onClick={toggleNotHeld}
        disabled={disabled}
        className="toggle-not-held"
        size="large"
      >
        {includeNotHeld ? <CenterFocusWeak /> : <CenterFocusStrong />}
      </IconButton>
    </div>
  </Tooltip>
}

ShowNotHeldButton.propTypes = {
  includeNotHeld: PropTypes.bool.isRequired,
  toggleNotHeld: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
